import $4DEO0$intlmenuarAEmjs from "../intl/menu/ar-AE.mjs";
import $4DEO0$intlmenubgBGmjs from "../intl/menu/bg-BG.mjs";
import $4DEO0$intlmenucsCZmjs from "../intl/menu/cs-CZ.mjs";
import $4DEO0$intlmenudaDKmjs from "../intl/menu/da-DK.mjs";
import $4DEO0$intlmenudeDEmjs from "../intl/menu/de-DE.mjs";
import $4DEO0$intlmenuelGRmjs from "../intl/menu/el-GR.mjs";
import $4DEO0$intlmenuenUSmjs from "../intl/menu/en-US.mjs";
import $4DEO0$intlmenuesESmjs from "../intl/menu/es-ES.mjs";
import $4DEO0$intlmenuetEEmjs from "../intl/menu/et-EE.mjs";
import $4DEO0$intlmenufiFImjs from "../intl/menu/fi-FI.mjs";
import $4DEO0$intlmenufrFRmjs from "../intl/menu/fr-FR.mjs";
import $4DEO0$intlmenuheILmjs from "../intl/menu/he-IL.mjs";
import $4DEO0$intlmenuhrHRmjs from "../intl/menu/hr-HR.mjs";
import $4DEO0$intlmenuhuHUmjs from "../intl/menu/hu-HU.mjs";
import $4DEO0$intlmenuitITmjs from "../intl/menu/it-IT.mjs";
import $4DEO0$intlmenujaJPmjs from "../intl/menu/ja-JP.mjs";
import $4DEO0$intlmenukoKRmjs from "../intl/menu/ko-KR.mjs";
import $4DEO0$intlmenultLTmjs from "../intl/menu/lt-LT.mjs";
import $4DEO0$intlmenulvLVmjs from "../intl/menu/lv-LV.mjs";
import $4DEO0$intlmenunbNOmjs from "../intl/menu/nb-NO.mjs";
import $4DEO0$intlmenunlNLmjs from "../intl/menu/nl-NL.mjs";
import $4DEO0$intlmenuplPLmjs from "../intl/menu/pl-PL.mjs";
import $4DEO0$intlmenuptBRmjs from "../intl/menu/pt-BR.mjs";
import $4DEO0$intlmenuptPTmjs from "../intl/menu/pt-PT.mjs";
import $4DEO0$intlmenuroROmjs from "../intl/menu/ro-RO.mjs";
import $4DEO0$intlmenuruRUmjs from "../intl/menu/ru-RU.mjs";
import $4DEO0$intlmenuskSKmjs from "../intl/menu/sk-SK.mjs";
import $4DEO0$intlmenuslSImjs from "../intl/menu/sl-SI.mjs";
import $4DEO0$intlmenusrSPmjs from "../intl/menu/sr-SP.mjs";
import $4DEO0$intlmenusvSEmjs from "../intl/menu/sv-SE.mjs";
import $4DEO0$intlmenutrTRmjs from "../intl/menu/tr-TR.mjs";
import $4DEO0$intlmenuukUAmjs from "../intl/menu/uk-UA.mjs";
import $4DEO0$intlmenuzhCNmjs from "../intl/menu/zh-CN.mjs";
import $4DEO0$intlmenuzhTWmjs from "../intl/menu/zh-TW.mjs";

var $8036f8b00d3c3911$exports = {};


































$8036f8b00d3c3911$exports = {
    "ar-AE": $4DEO0$intlmenuarAEmjs,
    "bg-BG": $4DEO0$intlmenubgBGmjs,
    "cs-CZ": $4DEO0$intlmenucsCZmjs,
    "da-DK": $4DEO0$intlmenudaDKmjs,
    "de-DE": $4DEO0$intlmenudeDEmjs,
    "el-GR": $4DEO0$intlmenuelGRmjs,
    "en-US": $4DEO0$intlmenuenUSmjs,
    "es-ES": $4DEO0$intlmenuesESmjs,
    "et-EE": $4DEO0$intlmenuetEEmjs,
    "fi-FI": $4DEO0$intlmenufiFImjs,
    "fr-FR": $4DEO0$intlmenufrFRmjs,
    "he-IL": $4DEO0$intlmenuheILmjs,
    "hr-HR": $4DEO0$intlmenuhrHRmjs,
    "hu-HU": $4DEO0$intlmenuhuHUmjs,
    "it-IT": $4DEO0$intlmenuitITmjs,
    "ja-JP": $4DEO0$intlmenujaJPmjs,
    "ko-KR": $4DEO0$intlmenukoKRmjs,
    "lt-LT": $4DEO0$intlmenultLTmjs,
    "lv-LV": $4DEO0$intlmenulvLVmjs,
    "nb-NO": $4DEO0$intlmenunbNOmjs,
    "nl-NL": $4DEO0$intlmenunlNLmjs,
    "pl-PL": $4DEO0$intlmenuplPLmjs,
    "pt-BR": $4DEO0$intlmenuptBRmjs,
    "pt-PT": $4DEO0$intlmenuptPTmjs,
    "ro-RO": $4DEO0$intlmenuroROmjs,
    "ru-RU": $4DEO0$intlmenuruRUmjs,
    "sk-SK": $4DEO0$intlmenuskSKmjs,
    "sl-SI": $4DEO0$intlmenuslSImjs,
    "sr-SP": $4DEO0$intlmenusrSPmjs,
    "sv-SE": $4DEO0$intlmenusvSEmjs,
    "tr-TR": $4DEO0$intlmenutrTRmjs,
    "uk-UA": $4DEO0$intlmenuukUAmjs,
    "zh-CN": $4DEO0$intlmenuzhCNmjs,
    "zh-TW": $4DEO0$intlmenuzhTWmjs
};


export {$8036f8b00d3c3911$exports as default};
//# sourceMappingURL=intlStrings.mjs.map
